import { useContext } from 'react';
import { LocaleContext } from 'src/contexts/LocaleContext';

const useLocaleContext = () => {
  const context = useContext(LocaleContext);
  if (!context) throw new Error('Locale context must be used inside LocaleContextProvider');
  return context;
};

export default useLocaleContext;
